import {
  FeatureCard as FeatureCardComponent,
  FeatureCardProps as FeatureCardComponentProps,
} from "@kunduz/feature-landing-pages";
import { ComponentConfig } from "@measured/puck";
import { cmsIcons } from "../../utils";

export interface FeatureCardProps extends FeatureCardComponentProps {}

const FeatureCard = (props: FeatureCardProps) => {
  return <FeatureCardComponent {...props} />;
};

export const PuckFeatureCard: ComponentConfig<FeatureCardProps> = {
  label: "Feature Card",
  fields: {
    badgeIcon: { type: "select", label: "Badge Icon", options: cmsIcons },
    badgeIconUrl: { type: "text", label: "Badge Icon URL" },
    title: { type: "text", label: "Title" },
    description: { type: "text", label: "Description" },
    urlText: { type: "text", label: "URL Text" },
    url: { type: "text", label: "URL" },
    backgroundColor: { type: "text", label: "Background Color" },
    style: {
      type: "object",
      label: "Options",
      objectFields: {
        maxWidth: { type: "text", label: "Max Width" },
      },
    },
  },
  defaultProps: {
    badgeIcon: "counseling",
    title:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    urlText:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    url: "",
  },
  render: (props) => <FeatureCard {...props} />,
};
